import type { StatRow } from '@betreuung/shared';
import { personVars } from '@/lib/personColor';
import type { PersonLookup } from '@/lib/persons';
import { describeStatRow, statRowKey } from './StatRowItem';

export interface StackedBarProps {
  rows: readonly StatRow[];
  persons: PersonLookup;
}

/**
 * The month's shares as one 14px bar. Segments grow proportionally to their slot
 * count, which keeps the bar exact at any width without percentage arithmetic.
 */
export function StackedBar({ rows, persons }: StackedBarProps) {
  return (
    <div className="mb-3.5 flex h-3.5 overflow-hidden rounded-chip" aria-hidden>
      {rows
        .filter((row) => row.slots > 0)
        .map((row) => {
          const { colorIndex } = describeStatRow(row, persons);
          return (
            <div
              key={statRowKey(row)}
              style={{
                flexGrow: row.slots,
                flexBasis: 0,
                minWidth: 0,
                ...(colorIndex === null ? {} : personVars(colorIndex)),
              }}
              className={colorIndex === null ? 'hatch' : 'person-bg'}
            />
          );
        })}
    </div>
  );
}
